import { Container, Header } from '@botpress/webchat'
import { WebchatComponentPreview } from './WebchatComponentPreview'
import type { LatestWebchatTheme } from '@bpinternal/shared'
import { useLocalStore } from '~/stores'
import { getUseConfigStore } from '../../stores/useConfigStore'
import { useMemo, useState } from 'react'

export const SoundSettingPreview = ({
  soundEnabled,
  botId,
  workspaceId,
}: {
  soundEnabled: boolean
  botId: string
  workspaceId: string
}) => {
  const [previewSoundEnabled, setPreviewSoundEnabled] = useState(soundEnabled)
  const useConfigStore = useMemo(() => getUseConfigStore({ botId, workspaceId }), [botId, workspaceId])

  const dashboardTheme = useLocalStore((state) => state.getPreferredTheme())
  const color = useConfigStore((state) => state.color)
  const variant = useConfigStore((state) => state.variant)
  const headerVariant = useConfigStore((state) => state.headerVariant)
  const radius = useConfigStore((state) => state.radius)

  const webchatTheme: LatestWebchatTheme = {
    themeMode: dashboardTheme,
    headerVariant,
    variant,
    color,
    radius,
  }

  return (
    <WebchatComponentPreview
      className="flex h-20 items-center justify-center rounded-lg border bg-gray-1 px-4 pt-3"
      theme={{ ...webchatTheme }}
    >
      <Container className="w-full !rounded-b-none !border-b-0">
        <Header
          configuration={{ soundEnabled }}
          toggleSound={() => setPreviewSoundEnabled(!previewSoundEnabled)}
          soundOn={previewSoundEnabled}
        />
      </Container>
    </WebchatComponentPreview>
  )
}
